// test2690
(2690 && 0);
